import { combineReducers } from 'redux';

import {
  ADD_SEARCH_TERM,
  CLEAR_DATA,
  CLEAR_RESULTS,
  LOAD_DATA_CHUNK,
  LOAD_SEARCH_TERMS,
  REMOVE_SEARCH_TERM,
  SET_LOADING,
  SET_SEARCH_TERMS,
  UPDATE_SEARCH_ID,
  UPDATE_SEARCH_MATCHES,
  UPDATE_SEARCH_TERM,
} from '../actions';

export const initialState = {
  allArtists: [],
  visibleArtists: [],
  invisibleArtists: [],
  copiedArtists: [],
  movedArtists: [],
  matches: undefined,
};

// The centralized reducer:
export function searchResults(state = initialState, action) {
  switch (action.type) {
    case CLEAR_DATA:
      return initialState;
    case CLEAR_RESULTS:
      return { ...state, allArtists: [] };
    case LOAD_DATA_CHUNK:
      return {
        ...state,
        allArtists: [...state.allArtists, ...action.artists],
        visibleArtists: [
          ...state.visibleArtists,
          ...action.artists.map((a) => a.artist_id),
        ],
      };
    case UPDATE_SEARCH_ID:
      return { ...state, searchId: action.searchId };
    case UPDATE_SEARCH_MATCHES:
      return { ...state, matches: action.matches };
    default:
      return state;
  }
}

function terms(state = null, action) {
  switch (action.type) {
    case ADD_SEARCH_TERM:
      return [...state, action.term];
    case REMOVE_SEARCH_TERM:
      return state.filter((t) => t.term_id !== action.termID);
    case UPDATE_SEARCH_TERM: {
      const newState = [...state];
      const index = newState.findIndex((v) => v.term_id === action.termID);
      const term = { ...newState[index], ...action.values };
      newState[index] = term;
      return newState;
    }
    case SET_SEARCH_TERMS:
      return action.terms;
    case LOAD_SEARCH_TERMS:
      return action.terms;
    case CLEAR_DATA:
      return [];
    default:
      return state;
  }
}

function isLoading(state = false, action) {
  switch (action.type) {
    case SET_LOADING:
      return action.loading;
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  searchResults,
  terms,
  isLoading,
});

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default rootReducer;
